import { z } from 'zod';

export const missionAIGenerateSchema = z.object({
  business_activities: z
    .string()
    .min(20, 'Business activities must be at least 20 characters')
    .refine(val => val === '' || val.split('.').length <= 2, {
      message: 'Maximum 1 sentence allowed',
    })
    .optional()
    .or(z.literal('')),
  hr_focus: z
    .string()
    .min(15, 'HR focus must be at least 15 characters')
    .refine(val => val === '' || val.split('.').filter(s => s.trim()).length >= 1, {
      message: 'Minimum 1 sentence required',
    })
    .optional()
    .or(z.literal('')),
  operational_focus: z
    .string()
    .min(5, 'Operational focus must be at least 5 characters')
    .refine(val => val === '' || val.trim().length > 0, {
      message: 'Cannot be just spaces',
    })
    .refine(val => val === '' || val.split('.').length <= 2, {
      message: 'Maximum 1 sentence allowed',
    })
    .optional()
    .or(z.literal('')),
  marketing_focus: z
    .string()
    .min(5, 'Marketing focus must be at least 5 characters')
    .refine(val => val === '' || val.split('.').length <= 2, {
      message: 'Maximum 1 sentence allowed',
    })
    .optional()
    .or(z.literal('')),
  finance_focus: z
    .string()
    .min(5, 'Finance focus must be at least 5 characters')
    .refine(val => val === '' || val.split('.').length <= 2, {
      message: 'Maximum 1 sentence allowed',
    })
    .optional()
    .or(z.literal('')),
});

export type MissionAIGenerateFormData = z.infer<typeof missionAIGenerateSchema>;
